import React, { useState } from 'react';

function Tooltip(props) {
  const [displayTooltip, setDisplayTooltip] = useState(false);

  function toggleToolTip() {
    setDisplayTooltip(!displayTooltip);
  }

  return (
    <div className="tooltip">
      {displayTooltip && (
        <div className={`tooltip-bubble tooltip-${props.position}`} style={{ transform: `translateX(${props.x}) translateY(${props.y})` }}>
          <a href={props.link} target="_blank" rel="noopener noreferrer" id={props.popupId}>
            <img src={props.popup} alt="learn more" />
          </a>
        </div>
      )}
      <span className="tooltip-trigger" onClick={toggleToolTip}>
        {props.children}
      </span>
    </div>
  );
}

export default Tooltip;
